import { defineStore } from 'pinia'
import {
  OneNetworkStoreAuthActionTypes
} from '@/onenetwork/constants/onenetwork.constant.action_type'
import { APIClient, clearToken, setToken } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { CHANGE_PW_API, CHECK_PHONE_EXIST_API, LOGIN_API, REQUEST_OTP_API, RESET_PW_API, VERIFY_OTP_API, FETCH_ME } from '@/onenetwork/constants/onenetwork.api.constant.ts'

export enum AuthActionTypes {
  LOADING = 'LOADING',
  LOGINED = 'LOGINED',
  LOGOUT = 'LOGOUT',
  FETCHING = 'FETCHING',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILURE = 'FETCH_FAILURE',
  LOGIN_FAILURE = 'LOGIN_FAILURE'
}

interface AuthState {
  action_type: AuthActionTypes | null,
  action_message: string | null,
  accessToken: string | null,
  refreshToken: string | null,
  user: any,
  error: Object | null,
}

export const useAuthStore = defineStore('onenetwork.auth', {
  state: (): AuthState => ({
    action_type: null,
    action_message: null,
    accessToken: null,
    refreshToken: null,
    user: null,
    error: null,
  }),
  persist: true,
  getters: {

  },

  actions: {
    reset(){
      this.user = null;
      this.accessToken = null;
      this.refreshToken = null;
      clearToken()
    },
    logout(){
      this.reset()
      this.action_type = AuthActionTypes.LOGOUT
    },
    login(credentials: {phone_number: string, password: string}) {
      return new Promise(async (resolve, reject) => {
        try{
          this.reset()
          this.action_type = AuthActionTypes.LOADING
          const res = await APIClient.post(LOGIN_API, credentials)

          this.user = res.data.data.user;
          this.accessToken = res.data.data.access_token;
          this.refreshToken = res.data.data.refresh_token;
          this.action_type = AuthActionTypes.LOGINED

          setToken( res.data.data.access_token)
          resolve(res)
        } catch (e) {
          this.action_type = AuthActionTypes.LOGIN_FAILURE

          reject(e)
        }
      })
    },
    fetchMe() {
      return new Promise(async (resolve, reject) => {
        try{
          const res = await APIClient.get(FETCH_ME)
          this.user = res.data.data;
          resolve(res)
        } catch (e) {
          this.reset()
          reject(e)
        }
      })
    },
    checkPhoneExist(phone_number: string) {
      return new Promise(async (resolve, reject) => {
        try{
          const params = {
            phone: phone_number,
            type: 'forgot_password'
          }
          const res = await APIClient.post(CHECK_PHONE_EXIST_API, params)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    requestOTP(phone_number: string) {
      return new Promise(async (resolve, reject) => {
        try{
          const params = {
            phone: phone_number,
            type: 'forgot_password'
          }
          const res = await APIClient.post(REQUEST_OTP_API, params)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    verifyOTP(phone_number: string, otp: string) {
      return new Promise(async (resolve, reject) => {
        try{
          const params = {
            phone: phone_number,
            code: otp
          }
          const res = await APIClient.post(VERIFY_OTP_API, params)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    resetPW(formData: {phone_number: string, password: string, password_confirmation: string}) {
      return new Promise(async (resolve, reject) => {
        try{
          const res = await APIClient.post(RESET_PW_API, formData)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    changePW(formData: {current_password: string, password: string, password_confirmation: string}) {
      return new Promise(async (resolve, reject) => {
        try{
          const res = await APIClient.post(CHANGE_PW_API, formData)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    setPerms(perms: string[]) {
      this.user.permissions = perms
    }
  }
})
